import { defineMessages } from 'react-intl';

export default defineMessages({
  previous: {
    id: 'legal_proceeding_page.validation_buttons.back',
  },
  validate: {
    id: 'legal_proceeding_page.validation_buttons.validate',
  },
  validator: {
    id: 'court_manager_legal_proceedings_page.step.validator',
  },
});
